import React, { useState } from "react";

const NotesCheckBox = (props) => {
   let { tempId, isDisable, className, UpdateNotes = () => {} } = props;
   const [toggle, setToggle] = useState(isDisable);
   return (
      <div
         onClick={(e) => {
            setToggle(toggle);
            e.stopPropagation();
         }}
         className={`d-flex justify-content-center align-items-center ${className}`}
      >
         <label className="checkbox-toggle-switch" style={{ width: `${props.width}`, height: `${props.height}` }}>
            <input
               type="checkbox"
               onChange={(e) => {
                  UpdateNotes(tempId, !toggle, () => {
                     setToggle(toggle);
                  });
                  setToggle(!toggle);
               }}
               checked={!toggle}
            />
            <span className={` ${toggle ? "lib-checkbox-toggle" : "checkbox-toggle"} round`}></span>
         </label>
      </div>
   );
};

export default NotesCheckBox;
